import React, { useState } from "react";
import { Box, Toolbar } from "@mui/material";
import Sidebar from "../../components/sidebar";
import Navbar from "../../components/navbar";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f2f4f8" }}>
            <Navbar onMenuClick={handleDrawerToggle} />

            <Sidebar
                mobileOpen={mobileOpen}
                handleDrawerToggle={handleDrawerToggle}
            />

            <Box component="main" sx={{ flexGrow: 1, width: { md: `calc(100% - 260px)` } }}>
                <Toolbar />
                <Box sx={{ p: 3.5, overflowX: 'hidden !important'}}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
};

export default DashboardLayout;